module.exports = __webpack_public_path__ + "static/media/pcs-pic2.091ac0a4.JPG";